/**
 * Enumeration of the different container types for planner plans
 */ export var ContainerType = /*#__PURE__*/ function(ContainerType) {
    /** Office document owned */ ContainerType["DriveItem"] = "driveItem";
    /** Modern M365 Group */ ContainerType["Group"] = "group";
    /** Online meeting */ ContainerType["OnlineMeeting"] = "onlineMeeting";
    /** Planner Task */ ContainerType["PlannerTask"] = "plannerTask";
    /** Project */ ContainerType["Project"] = "project";
    /** Planner roster */ ContainerType["Roster"] = "roster";
    /** Microsoft Teams Channel */ ContainerType["TeamsChannel"] = "teamsChannel";
    /** Todo container. This is a client augmentation for casting Todo behavior into Planner behavior */ ContainerType["ToDo"] = "todo";
    /** AAD User */ ContainerType["User"] = "user";
    return ContainerType;
}({});
/**
 * Enumeration of the different custom field value types
 */ export var CustomFieldValueType = /*#__PURE__*/ function(CustomFieldValueType) {
    /** Text type custom field */ CustomFieldValueType["Text"] = "text";
    /** Number type custom field */ CustomFieldValueType["Number"] = "number";
    /** Date type custom field */ CustomFieldValueType["Date"] = "date";
    /** Binary Flag type custom field */ CustomFieldValueType["Flag"] = "flag";
    /** Single choice text type custom field */ CustomFieldValueType["SingleChoiceText"] = "singleChoiceText";
    return CustomFieldValueType;
}({});
/**
 * Enumeration of the different custom field rollup types
 */ export var CustomFieldRollup = /*#__PURE__*/ function(CustomFieldRollup) {
    /** No rollup for the custom field */ CustomFieldRollup["NoRollup"] = "noRollup";
    /** Sum rollup for the custom field */ CustomFieldRollup["Sum"] = "sum";
    /** Average rollup for the custom field */ CustomFieldRollup["Average"] = "average";
    /** Rollup the min value for the custom field */ CustomFieldRollup["Min"] = "min";
    /** Rollup the max value for the custom field */ CustomFieldRollup["Max"] = "max";
    return CustomFieldRollup;
}({});
/**
 * Enumeration of the different content link types
 */ export var ContentLinkType = /*#__PURE__*/ function(ContentLinkType) {
    /** The link is to a document */ ContentLinkType["DocumentReference"] = "documentReference";
    /** The link is to a web endpoint */ ContentLinkType["WebReference"] = "webReference";
    /** The link is to another app */ ContentLinkType["HostedApp"] = "hostedApp";
    /** The link is to a Forms form */ ContentLinkType["Form"] = "form";
    return ContentLinkType;
}({});
/**
 * Enumeration of the different supported legacy document reference types for content links
 */ export var DocumentReferenceLegacyType = /*#__PURE__*/ function(DocumentReferenceLegacyType) {
    DocumentReferenceLegacyType["Word"] = "Word";
    DocumentReferenceLegacyType["Excel"] = "Excel";
    DocumentReferenceLegacyType["PowerPoint"] = "PowerPoint";
    DocumentReferenceLegacyType["Visio"] = "Visio";
    DocumentReferenceLegacyType["Pdf"] = "Pdf";
    return DocumentReferenceLegacyType;
}({});
/**
 * Enumeration of the different supported legacy web reference types for content links
 */ export var WebReferenceLegacyType = /*#__PURE__*/ function(WebReferenceLegacyType) {
    WebReferenceLegacyType["OneNote"] = "OneNote";
    WebReferenceLegacyType["Project"] = "Project";
    WebReferenceLegacyType["Other"] = "Other";
    return WebReferenceLegacyType;
}({});
/**
 * Enumeration of the different supported legacy hosted app reference types for content links
 */ export var HostedAppReferenceLegacyType = /*#__PURE__*/ function(HostedAppReferenceLegacyType) {
    HostedAppReferenceLegacyType["TeamsHostedApp"] = "TeamsHostedApp";
    return HostedAppReferenceLegacyType;
}({});
/**
 * Enumeration of the different recurrence end types
 */ export var RecurrenceEndType = /*#__PURE__*/ function(RecurrenceEndType) {
    /** End of the plan */ RecurrenceEndType["EndOfPlan"] = "endOfPlan";
    /** End by a specific date */ RecurrenceEndType["ByDate"] = "byDate";
    /** End after a specific count */ RecurrenceEndType["ByCount"] = "byCount";
    return RecurrenceEndType;
}({});
/**
 * Enumeration of the different recurrence pattern types
 */ export var RecurrencePatternType = /*#__PURE__*/ function(RecurrencePatternType) {
    /** Daily recurrence pattern */ RecurrencePatternType["Daily"] = "daily";
    /** Weekly recurrence pattern */ RecurrencePatternType["Weekly"] = "weekly";
    /** Recur monthly on the fixed day */ RecurrencePatternType["FixedDayOfMonth"] = "absoluteMonthly";
    /** Recur monthly on the relative day */ RecurrencePatternType["RelativeDayOfMonth"] = "relativeMonthly";
    /** Recur yearly on the fixed day */ RecurrencePatternType["FixedDayOfYear"] = "absoluteYearly";
    /** Recur yearly on the relative day */ RecurrencePatternType["RelativeDayOfYear"] = "relativeYearly";
    return RecurrencePatternType;
}({});
/**
 * Enumeration of the different dependency item types
 */ export var DependencyItemType = /*#__PURE__*/ function(DependencyItemType) {
    /** Task dependency */ DependencyItemType["Task"] = "task";
    return DependencyItemType;
}({});
/**
 * Enumeration of the different dependency types
 */ export var DependencyType = /*#__PURE__*/ function(DependencyType) {
    DependencyType["SourceStartDrivesTargetStart"] = "sourceStartDrivesTargetStart";
    DependencyType["SourceFinishDrivesTargetStart"] = "sourceFinishDrivesTargetStart";
    DependencyType["SourceFinishDrivesTargetFinish"] = "sourceFinishDrivesTargetFinish";
    DependencyType["TargetStartDrivesSourceFinish"] = "targetStartDrivesSourceFinish";
    return DependencyType;
}({});
/**
 * Enumeration of the different Goal statuses
 */ export var GoalStatus = /*#__PURE__*/ function(GoalStatus) {
    GoalStatus["NotStarted"] = "notStarted";
    GoalStatus["OnTrack"] = "onTrack";
    GoalStatus["Behind"] = "behind";
    GoalStatus["AtRisk"] = "atRisk";
    GoalStatus["Closed"] = "closed";
    return GoalStatus;
}({});
/**
 * Enumeration of the different access levels possible on a plan
 */ export var PlanAccessLevel = /*#__PURE__*/ function(PlanAccessLevel) {
    /** The user has only read access to the plan */ PlanAccessLevel["Read"] = "read";
    /** The user has write access to the plan */ PlanAccessLevel["Write"] = "write";
    /** The user has full access to the plan */ PlanAccessLevel["Full"] = "full";
    return PlanAccessLevel;
}({});
/**
 * Assignment method for sensitivity label
 */ export var SensitivityLabelAssignmentMethod = /*#__PURE__*/ function(SensitivityLabelAssignmentMethod) {
    /** The assignment method for the label is standard*/ SensitivityLabelAssignmentMethod["Standard"] = "standard";
    /**
     * The assignment method for the label is privileged
     * Indicates that the label is applied manually by a user or by an admin.
     */ SensitivityLabelAssignmentMethod["Privileged"] = "privileged";
    /**
     * The assignment method for the label is automatic
     * Indicates that the label is applied automatically by the system due to a configured policy
     */ SensitivityLabelAssignmentMethod["Auto"] = "auto";
    /**
     * The assignment method for the label is unknown
     */ SensitivityLabelAssignmentMethod["UnknownFutureValue"] = "unknownFutureValue";
    return SensitivityLabelAssignmentMethod;
}({});
/**
 * Action source for sensitivity label assignment
 */ export var SensitivityLabelActionSource = /*#__PURE__*/ function(SensitivityLabelActionSource) {
    /** The label was applied manually by a user */ SensitivityLabelActionSource["Manual"] = "manual";
    /** The label was applied automatically by the system */ SensitivityLabelActionSource["Automatic"] = "automatic";
    /** The label was applied as a recommendation */ SensitivityLabelActionSource["Recommended"] = "recommended";
    /** The label was applied as the default */ SensitivityLabelActionSource["Default"] = "default";
    /** Unknown future value */ SensitivityLabelActionSource["UnknownFutureValue"] = "unknownFutureValue";
    return SensitivityLabelActionSource;
}({});
/**
 * Enumeration of the different task status
 */ export var TaskStatus = /*#__PURE__*/ function(TaskStatus) {
    /** The task is not started */ TaskStatus["NotStarted"] = "notStarted";
    /** The task is in progress */ TaskStatus["InProgress"] = "inProgress";
    /** The task is completed */ TaskStatus["Completed"] = "completed";
    return TaskStatus;
}({});
/**
 * List of the different planner features supported for capability checks
 * @remarks Adding a made up feature for now, we will populate this list with real features once the list is finalized
 */ export const PlannerFeatures = [
    "entityExtensions"
];
/** Options for copying a plan */ export var CopyPlanOptions = /*#__PURE__*/ function(CopyPlanOptions) {
    /** No options selected */ CopyPlanOptions["None"] = "none";
    /** Copy task references */ CopyPlanOptions["CopyTaskReferences"] = "copyTaskReferences";
    /** Copy task checklists */ CopyPlanOptions["CopyTaskChecklists"] = "copyTaskChecklists";
    /** Copy task dates */ CopyPlanOptions["CopyTaskDates"] = "copyTaskDates";
    /** Copy task descriptions */ CopyPlanOptions["CopyTaskDescriptions"] = "copyTaskDescriptions";
    /** Copy plan and task categories */ CopyPlanOptions["CopyPlanAndTaskCategories"] = "copyPlanAndTaskCategories";
    /** Copy task priorities */ CopyPlanOptions["CopyTaskPriorities"] = "copyTaskPriorities";
    /** Copy Goals */ CopyPlanOptions["CopyGoals"] = "copyGoals";
    /** Copy Task recurrence schedule */ CopyPlanOptions["CopyTaskRecurrence"] = "copyTaskRecurrence";
    /** Copy custom field definitions */ CopyPlanOptions["CopyCustomFieldDefinitions"] = "copyCustomFieldDefinitions";
    /** Copy custom field values */ CopyPlanOptions["CopyCustomFieldValues"] = "copyCustomFieldValues";
    return CopyPlanOptions;
}({});
/** Options for publishing a plan as template */ export var PublishPlanAsTemplateShareOptions = /*#__PURE__*/ function(PublishPlanAsTemplateShareOptions) {
    /** No options selected */ PublishPlanAsTemplateShareOptions["None"] = "none";
    /** Copy task references */ PublishPlanAsTemplateShareOptions["CopyTaskReferences"] = "includeReferences";
    /** Copy task checklists */ PublishPlanAsTemplateShareOptions["CopyTaskChecklists"] = "includeChecklists";
    /** Copy plan and task categories */ PublishPlanAsTemplateShareOptions["CopyPlanAndTaskCategories"] = "includeCategories";
    /** Copy Goals */ PublishPlanAsTemplateShareOptions["CopyGoals"] = "includeGoals";
    /** Copy task notes */ PublishPlanAsTemplateShareOptions["CopyTaskNotes"] = "includeNotes";
    /** Copy buckets */ PublishPlanAsTemplateShareOptions["CopyBuckets"] = "includeBuckets";
    return PublishPlanAsTemplateShareOptions;
}({});
/** Long running operation status */ export var LongRunningOperationStatus = /*#__PURE__*/ function(LongRunningOperationStatus) {
    /** Status indicating operation is not complete. Indicator to continue polling. */ LongRunningOperationStatus["Running"] = "running";
    /** Status indicating operation has completed successfully. */ LongRunningOperationStatus["Success"] = "success";
    /** Status indicating operation is in progress and has produced a result. */ LongRunningOperationStatus["InProgressWithResult"] = "inProgressWithResult";
    /** Status indicating operation has completed with a failure. */ LongRunningOperationStatus["Failed"] = "failed";
    return LongRunningOperationStatus;
}({});
